import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createTagGroupVisibleSelector } from "../../store/selectors";
import { setTagGroupVisible } from "../../store/actions";
import SwitcherHeader from "../switcher/SwitcherHeader";
export function TagSwitcherHeader({ featureSourceId, tagGroup, toggleable, }) {
    const dispatch = useDispatch();
    const visibility = useSelector(createTagGroupVisibleSelector(featureSourceId, tagGroup));
    const toggleActive = useMemo(() => toggleable
        ? () => dispatch(setTagGroupVisible(featureSourceId, tagGroup, !visibility))
        : undefined, [dispatch, featureSourceId, tagGroup, toggleable, visibility]);
    return (_jsx(SwitcherHeader, { label: tagGroup, active: !toggleable || visibility, toggleActive: toggleActive }));
}
